export const BLOG_TAGS = [
  "All",
  "AI Engineering",
  "AI Agents",
  "Web Engineering",
  "Mobile",
  "Blockchain",
  "Culture",
];

export const BLOG_CARD_GRADIENTS = [
  "from-indigo-900 via-blue-900 to-slate-950",
  "from-cyan-900 via-blue-900 to-slate-950",
  "from-violet-900 via-indigo-900 to-slate-950",
  "from-emerald-900 via-teal-900 to-slate-950",
  "from-sky-900 via-blue-900 to-slate-950",
  "from-rose-900 via-fuchsia-900 to-slate-950",
];
